export default "__VITE_ASSET__a4647b55__"